import { EXPORT_TYPES } from '../util'

export const validateEmail = (emailToSendTo, exportType) => {
  if (exportType !== EXPORT_TYPES.email_pdf.id) {
    return true
  }
  return emailToSendTo.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
}

export const validateDateRange = (dateRangeMode, dialogStartDate, customDateRange) => {
  if (dateRangeMode === 'monthly') {
    return dialogStartDate && dialogStartDate.isValid()
  }
  return customDateRange && customDateRange[0] && customDateRange[1]
}
